import { defineComponent } from "vue";
const _sfc_main = defineComponent({
  name: "FileScale"
});
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "currentColor",
  viewBox: "0 0 24 24"
};
const _hoisted_2 = /* @__PURE__ */ _createElementVNode("path", {
  "fill-rule": "evenodd",
  d: "M12.75 17.25V18.75H17.25C18.0784 18.75 18.75 18.0784 18.75 17.25V6.75C18.75 5.92157 18.0784 5.25 17.25 5.25H6.75C5.92157 5.25 5.25 5.92157 5.25 6.75V11.25H6.75V6.75H17.25V17.25H12.75ZM9.75 12.75H5.25C4.42157 12.75 3.75 13.4216 3.75 14.25V18.75C3.75 19.5784 4.42157 20.25 5.25 20.25H9.75C10.5784 20.25 11.25 19.5784 11.25 18.75V14.25C11.25 13.4216 10.5784 12.75 9.75 12.75ZM5.25 14.25V18.75H9.75V14.25H5.25Z",
  "clip-rule": "evenodd"
}, null, -1);
const _hoisted_3 = [
  _hoisted_2
];
function _sfc_render(_ctx, _cache, $props, $setup, $data, $options) {
  return _openBlock(), _createElementBlock("svg", _hoisted_1, _hoisted_3);
}
import _export_sfc from "/plugin-vue/export-helper";
export default /* @__PURE__ */ _export_sfc(_sfc_main, [["render", _sfc_render], ["__file", "/Users/yimingtian/projects/ym/yimian-ui/packages/icons/src/FileScale.vue"]]);
